import { type RestaurantEvent } from './restaurants';

export interface ShiftOccurrence {
  date: string;
  startTime: string;
  endTime: string;
}

export interface Shift {
  id: string;
  name: string;
  startDate: string;
  endDate: string | null;
  repeat: string[];
  startTime: string;
  endTime: string;
  occurrences: ShiftOccurrence[];
  isRecurring: boolean;
  restaurantId: string;
}

export interface Listing {
  id: string;
  iconName: string;
  floorPlanId: string;
  name: string;
  price: number;
}

export interface ExpandedShift extends Shift {
  highlightedFloorPlanTableIds: string[];
  listings: Listing[];
  restaurantEvent: RestaurantEvent | null;
  lastOccurrenceDateWithinNextYear?: string;
}

export const END_OF_RESTAURANT_DAY = '04:00:00';
